import { ReactNode } from 'react';
import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import { prefersReducedMotion } from '../../utils/animations';

interface PageTransitionProps {
	children: ReactNode;
}

/**
 * PageTransition - Smooth page transition wrapper
 * Uses framer-motion for page transitions with AnimatePresence
 */
const PageTransition = ({ children }: PageTransitionProps) => {
	const location = useLocation();
	const shouldAnimate = !prefersReducedMotion();

	if (!shouldAnimate) {
		return <>{children}</>;
	}

	const pageVariants = {
		initial: {
			opacity: 0,
			y: 20,
			scale: 0.98,
		},
		animate: {
			opacity: 1,
			y: 0,
			scale: 1,
		},
		exit: {
			opacity: 0,
			y: -20,
			scale: 0.98,
		},
	};

	const pageTransition = {
		type: 'tween',
		ease: [0.25, 0.46, 0.45, 0.94],
		duration: 0.4,
	};

	return (
		<motion.div
			key={location.pathname}
			initial="initial"
			animate="animate"
			exit="exit"
			variants={pageVariants}
			transition={pageTransition}
		>
			{children}
		</motion.div>
	);
};

export default PageTransition;
